import Cookies from 'js-cookie';

export const setCookie = (
  name: string,
  value: string | object,
  settings?: Cookies.CookieAttributes
) => {
  try {
    Cookies.set(name, value, settings);
  } catch (e) {
    console.warn(e, 'cookies error');
  }
};

export const getCookie = <T>(name: string, defaultValue?: T) => {
  try {
    return Cookies.get(name) || defaultValue;
  } catch (e) {
    console.warn(e, 'cookies error');

    return null;
  }
};

export const removeCookie = (
  name: string,
  attributes?: Cookies.CookieAttributes
) => {
  try {
    return Cookies.remove(name, attributes);
  } catch (e) {
    console.warn(e, 'cookies error');

    return null;
  }
};
